import React from "react";
import { Link } from "react-router";
import { routes } from "../../routes";

const Breadcrumb = ({ breadcrumbs }) => {
  const routeNames = [routes.HOME.replace("/", ""), routes.ADVISOR_TOPIC_DETAILS.replace("/", "")];

  const filteredBreadcrumbs = (breadcrumbs || []).filter((item, index) => {
    if (index > 0 && (breadcrumbs[index - 1] === "advisors-word-details" || breadcrumbs[index - 1] === "advisors-profile")) {
      return false;
    }
    if (/^[0-9a-fA-F]{24}$/.test(item)) {
      return false;
    }
    return true;
  });

  return (
    !routeNames.includes(breadcrumbs?.[0]) && (
      <nav className="flex flex-wrap gap-x-2 mt-3" aria-label="Breadcrumb">
        <Link
          to={routes.HOME}
          className="text-gray-500 uppercase hover:text-primary text-sm md:text-base"
        >
          Home
        </Link>
        <ol className="inline-flex flex-wrap items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
          {filteredBreadcrumbs.map((item, index) => (
            <li key={index} className="inline-flex items-center capitalize text-gray-500 font-bold text-sm md:text-base">
              <svg className="w-3 h-3 text-gray-500 mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 5 7 7-7 7" />
              </svg>
              {item === "history" ? "My Trip" : item}
            </li>
          ))}
        </ol>
      </nav>
    )
  );
};

export default Breadcrumb;
